<script setup>
import moment from "moment";

const props = defineProps({
  id: [String, Number],
  title: String,
  publishedAt: String,
});

const url = computed(() => `/articles/${props.id}`);

const { formatDate } = useFormatters();

const isFuture = computed(() => {
  if (!props.publishedAt) return false;
  return moment(props.publishedAt).isAfter(moment());
});
</script>

<template lang="pug">
nuxt-link.article-summary(:to="url")
  UiFlex(col, justify="between", items="stretch")
    .title {{ props.title }}
    .time(v-if="!isFuture") {{ formatDate(props.publishedAt) }}
</template>

<style lang="scss" scoped>
.article-summary {
  background: #f8fcff;
  box-shadow: 0 2px 30px 0 rgba(42, 103, 235, 0.1);
  border-radius: 20px;
  box-sizing: border-box;
  padding: 1em;
  position: relative;
  height: 100%;
  min-width: 300px;

  .title {
    font-weight: bold;
    margin-bottom: 1em;
    font-size: 1.4em;
    background: white;
    padding: 1em;
    border: 1px dashed #b7d9ff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 22px 20px;
    position: relative;
  }
  .time {
    color: #888;
    padding: 0.5em 1em;
  }
}
</style>